import React,{useState,useEffect,useRef} from "react";
import { Helmet } from 'react-helmet';
import { configData } from "../config";
import {useNavigate} from 'react-router-dom';
import Loading from './Loading';
//import SalespersonSidebar from "./SalespersonSidebar";
import { DataGrid } from '@mui/x-data-grid';
import Select from 'react-dropdown-select';
import DatePicker from 'react-datepicker';
import { format } from "date-fns";
import 'react-datepicker/dist/react-datepicker.css';
import './classes/ManagePeople.css';
import './classes/UserAdvanceSearch.css';
import { Link } from '@mui/material';

const columns = [
  
  { field: 'username', headerName: 'Username',sortable: false,cellClassName:'user_name_column',headerClassName:'user_name_header', flex:1,minWidth:155, renderCell: (params) => (
      <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.username}
      </Link>
    )},
  { field: 'first_name', headerName: 'First Name',sortable: false,cellClassName:'first_name_column',headerClassName:'first_name_header' ,minWidth:120, flex:1},
  { field: 'last_name', headerName: 'Last Name',sortable: false,cellClassName:'last_name_column',headerClassName:'last_name_header',minWidth:120, flex:1},
  { field: 'rid', headerName: 'Roles',sortable: false,cellClassName:'roles_column',headerClassName:'roles_header',minWidth:170, flex:1},
  { field: 'status', headerName: 'Active',sortable: false,cellClassName:'active_column',headerClassName:'active_header',minWidth:100, flex:1, renderCell: (params) => (
      <img src={params.row.status}></img>
    )},
  { field: 'created_at', headerName: 'Created date',sortable: false,cellClassName:'created_column',headerClassName:'created_header',minWidth:120, flex:1},
    { field: 'updated_at', headerName: 'Updated date',sortable: false,cellClassName:'updated_column',headerClassName:'updated_header',minWidth:120, flex:1},
  {
    field: 'edit_link',
    headerName: 'Edit Link',
    cellClassName:'edit_column',headerClassName:'edit_header',
    minWidth:55,
  //  flex:1, 
    renderCell: (params) => (
      <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer"  style={{ color: "#2C99D2"}}>
        Edit
      </Link>
    ),
    sortable: false
  },
];
const SportsreferrerOptions = [
    "Baseball America",
    "DegreesinSports.com",
    "Dr. Lashbrook gave me his business card!",
    "ESPN",
    "Fox Sports Radio",
    "Hockey News",
    "My professor",
    "NASSM",
    "NCAA News",
    "Other",
    "Racingjunk.com",
    "Rah Rah Rugby",
    "Search Engine",
    "Sherdog.com",
    "SLAM magazine",
    "SMWW Alumni told me about it",
    "SMWW Faculty",
    "WorkinSports.com"
]
const EducationlevelOptions = [
    "High School Diploma",
    "Some college",
    "Bachelor's Degree",
    "Master's Degree",
    "Doctoral Degree"
]
const appStatusOptions = [
  { value: "All", label: "-Any-" },
  { value: "1", label: "Denied" },
  { value: "2", label: "Pending" },
  { value: "3", label: "Approved need payment" },
  { value: "4", label: "Approved and paid" },
  { value: "5", label: "Approved and fee waived" },
  { value: "6", label: "Approved and paid in partial" },
  { value: "7", label: "Didn't take class" },
  { value: "8", label: "Job app" },
  { value: "9", label: "More info request" },
  { value: "10", label: "Talk to Lynn" },
  { value: "11", label: "India Meet and Greet" }
];
const UserAdvancedSearch = () =>{
    const [isLoading, setIsLoading] = useState(true);
    const app_url = configData.APP_URL;
    const currentDate = new Date();
    const startDateRef = useRef(null);
const endDateRef = useRef(null);
    const CreatedstartDateRef = useRef(null);
const CreatedendDateRef = useRef(null);
    const UpdatedstartDateRef = useRef(null);
const UpdatedendDateRef = useRef(null);
    const navigate = useNavigate();
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const [statelist, setStateList] = useState({});
    const [countriesList, setCountriesList] = useState([]);
    const [roleList, setRoleList] = useState({});
    const [selectedcountry, setSelectedCountry] = useState([{label: 'ALL', value: 'ALL' }]);
    const[salespersonList, setSalespersonList] = useState({});
    useEffect(() => {
      Promise.all([
        retrieveCountriesList(),
        retrieveStateList(),
        getsalespersonlist(), 
        getroleslist(),        
        
      ]).then(() => {

        setIsLoading(false);
      })
    }, []);
      const initialFormData = {
        field_first_name_value: '',
        field_last_name_value:'',
        name:'',
        field_city_value:'',
        field_postal_code_value:'',
        field_phone_value:'',
        field_secondary_phone_value:'',
        field_street_value:'',
        field_college_value:'',
        field_referrer_value:'',
        field_gender_value:'',
        field_country_value:'ALL',
        field_state_value:'',
        rid: '',
        status:'',
        field_military_value:'',
        field_reg_step_value:[],
        field_highest_grade_value:'',
        field_dormant_value:'',
        field_app_status_value:'',
        field_user_assignment_value:'',
        "field_birthday_value[min][date]":'',
        "field_birthday_value[min][date]_obj":null,
        "field_birthday_value[max][date]":'',
        "field_birthday_value[max][date]_obj":null,
        "created[min]":'',
        "created[min]_obj":null,
        "created[max]":'',
        "created[max]_obj":null,
        "field_date_of_app_value[min][date]":'',
        "field_date_of_app_value[min][date]_obj":null,
        "field_date_of_app_value[max][date]":'',
        "field_date_of_app_value[max][date]_obj":null,
        field_elaborate_value:'',
        field_team_organization_value:'',
        action: ''
  
      };
    const [formData, setFormData] = useState(initialFormData);
    const [formErrors, setFormErrors] =useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);  
    const [appliedFormData, setAppliedFormData] = useState(initialFormData);
    const [isReportViewLoading, setIsReportViewLoading] = useState(true);
 
// const handleChange = (event) => {
//     const { name, value } = event.target;
//     setformData({ ...formData, [name]: value });
    
//   };
const handleChange = (event) => {
  const { name, value, type, multiple, selectedOptions } = event.target;

  let newValue;

  if (multiple) {
    // For multi-select, collect all selected values into an array
    newValue = Array.from(selectedOptions, (option) => option.value);
  } else {
    // For other inputs, just take the value
    newValue = value;
  }

  setFormData((prev) => ({
    ...prev,
    [name]: newValue,
  }));
};


// const handleDateChange = (name, date) => {
//   const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
//   setFormData((prev) => ({
//     ...prev,
//     [name]: formattedDate
//   }));
// };
  const handleDateChange = (date, field) => {
    if (!date) {
      setFormData(prev => ({
        ...prev,
        [`${field}_obj`]: null,
        [field]: ''
      }));
      return;
    }

    const safeDate = new Date(date);
    safeDate.setHours(12, 0, 0, 0);

    setFormData(prev => ({
      ...prev,
      [`${field}_obj`]: date,
      [field]: format(safeDate, 'yyyy-MM-dd') 
    }));
  };
  React.useEffect(() => {
    if (isReportViewLoading) return;
    const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
       try {
        setIsLoading(true);
      const response = await fetch(app_url+'useradvancedsearch/getlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          // formData:formData
          formData: {
            ...appliedFormData,
            action: isSubmitted ? 'submit' : ''
          }
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
            if (isSubmitted) {
              setIsSubmitted(false);
            }
          }
    };
    

    fetchData();
  }, [paginationModel, sortModel, filterModel, appliedFormData, isReportViewLoading]); // Re-fetch data when these change


  /* Pagination, filter config ends here */
  const handleOpen = () => {
    setSelectedCountry([]);
    setFormData(prevState => ({
      ...prevState,
      field_country_value:''
    }));

  };


   async function retrieveStateList() {
    const statelistresponse = await fetch(
      app_url+'smwwstates/getstatelist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const statelistdata = await statelistresponse.json();
    
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      
      statelist[key] = statelistdata.data.result[key];
    
    });
    setStateList(statelist);
   
  }
  async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getreportcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

   // setCountriesList(countrieslistdata.data.result);
     const countries = Array.isArray(countrieslistdata?.data?.result)
    ? countrieslistdata.data.result
    : [];

      setCountriesList([
        { value: "ALL", label: "All" },
        ...countries
      ]);   
    
    
  }
  async function getsalespersonlist() {
    
         try {
            const response = await fetch(
                app_url+'user/getsalespersonlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        
  }
  async function getroleslist() {
    
         try {
            const response = await fetch(
                app_url+'useradvancedsearch/getroleslist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setRoleList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        
  }
  const validateDates = (formData) => {
  let errors = {};

  // Validate Birthdate Range
  if (formData["field_birthday_value[min][date]"] && formData["field_birthday_value[max][date]"]) {
    if (new Date(formData["field_birthday_value[max][date]"]) < new Date(formData["field_birthday_value[min][date]"])) {
      errors["field_birthday_value[max][date]"] = "Start date can't over end date.";
    }
  }

  // Validate Created Date Range
  if (formData["created[min]"] && formData["created[max]"]) {
    if (new Date(formData["created[max]"]) < new Date(formData["created[min]"])) {
      errors["created[max]"] = "Start date can't over end date.";
    }
  }

  // Validate Updated Date Range
  if (formData["field_date_of_app_value[min][date]"] && formData["field_date_of_app_value[max][date]"]) {
    if (new Date(formData["field_date_of_app_value[max][date]"]) < new Date(formData["field_date_of_app_value[min][date]"])) {
      errors["field_date_of_app_value[max][date]"] = "Start date can't over end date.";
    }
  }

  return errors;
};
const handleSubmit = async (e) => {
  e.preventDefault();
      const errors = validateDates(formData);

  if (Object.keys(errors).length > 0) {
    console.log("Validation errors:", errors);
    setFormErrors(errors); 
    return;
  }
   setFormErrors({});
   // Reset pagination state
                setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
    setAppliedFormData({...formData});
    setIsSubmitted(true);
//   try {
//      setIsLoading(true);
//    // console.log("Submitting formData:", formData);
// const response = await fetch(app_url+'useradvancedsearch/getlist', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//          page: 0,
//                pageSize: 50,
//           sortModel,
//           filterModel,
//           formData:formData
//         }),
//       });
//       const data = await response.json();
//       console.log(data.data.rows);
//       setRows(data.data.rows);
//       setRowCount(data.data.totalRowCount); // Server should return totalRowCount
//       }  catch (error) {
//             console.error('Error fetching data:', error);
//           } finally {
//             setIsLoading(false); // Set loading to false after fetch completes (success or error)
//           }
  
}; 
const handleExport = async (e) => {
        e.preventDefault(); // stop page reload
     const errors = validateDates(formData);

  if (Object.keys(errors).length > 0) {
    console.log("Validation errors:", errors);
    setFormErrors(errors); 
    return;
  }
   setFormErrors({});
   
        try {
            setIsLoading(true);
            const response = await fetch(app_url+'useradvancedsearch/getexport', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    formData:formData
                }),
            });
            const data = await response.json();
           const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    };
  const handleReset = async (e) => {
    //setFormData(initialFormData);  
    setSelectedCountry([{label: 'ALL', value: 'ALL' }]); 
    setFormData({
      ...initialFormData,
      field_country_value: 'ALL', 
    });  
    setAppliedFormData({
      ...initialFormData,
      field_country_value: 'ALL', 
    });  
      e.preventDefault();
   // Reset pagination state
                setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
  try {
     setIsLoading(true);
   // console.log("Submitting formData:", formData);
const response = await fetch(app_url+'useradvancedsearch/getlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
         page: 0,
               pageSize: 50,
          sortModel,
          filterModel,
          formData:initialFormData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }      
  };

const submitFormData = async (data) => {
  setAppliedFormData(data);
  setIsSubmitted(false);
};

const normalizeBackendData = (backendParams) => {
  const result = { ...backendParams };

  Object.keys(backendParams).forEach((key) => {
    const value = backendParams[key];

    if (
      typeof value === "string" &&
      /^\d{4}-\d{2}-\d{2}/.test(value)
    ) {
      result[`${key}_obj`] = value
        ? new Date(value.replace(/-/g, "/") + " 00:00:00")
        : null;
    }
  });

  return result;
};

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const reportViewId = params.get("report_view_id");

  const baseForm = initialFormData; 

  if (reportViewId) {
    const fetchData = async () => {
      try {
        const res = await fetch(app_url + 'report/getreportfilters', {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: reportViewId }),
        });

        const data = await res.json();
        const backendParams = data?.data?.params || {};

        //  normalize backend
        const normalized = normalizeBackendData(backendParams);

        //  merge (backend overrides URL/defaults)
        const finalData = {
          ...baseForm,
          ...normalized,
        };

        setFormData(finalData);
        submitFormData(finalData);

      } catch (err) {
        console.error(err);
      } finally {
        setIsReportViewLoading(false); 
      }
    };

    fetchData();
  } else {
    //  fallback → only URL/default
    // if ([...params.keys()].length > 0) {
      setFormData(baseForm);
      submitFormData(baseForm);
    // }
    setIsReportViewLoading(false); 
  }

}, []);

    return(
         <>
            {isLoading ? (
                <Loading />
            ) : (
            <div id="main">
              <Helmet>
                  <title>
                      User Advanced search List
                  </title>
              </Helmet>
              <div className="left"></div>
              <div className="center left-center">
                <div className="user-advance-search-container">
                  <div className="action-button">
                    <a href="/admin/people/create" className="form-submit  manage_people_adduserbtn">Add user</a>
                  </div> 
                  <input type="button" value="Export" onClick={handleExport}></input>
                  <div className="all-filters">
                      <form className="user-advance-search-form">
                        <div className="filter-field-widgets-1">                                        
                            <label htmlFor="field-first-name">First Name</label>
                              <input
                                type="text"
                                id="field-first-name"
                                name="field_first_name_value"
                                size="30"
                                maxLength="128"
                                value= {formData.field_first_name_value}
                                className="" 
                                onChange={handleChange}
                            />                                        
                        </div>
                        <div className="filter-field-widgets-1">  
                          <label htmlFor="field-last-name">Last Name</label>
                              <input
                                type="text"
                                id="field-last-name"
                                name="field_last_name_value"
                                size="30"
                                maxLength="128"
                                value= {formData.field_last_name_value}
                                className=""
                                onChange={handleChange}
                            />
                        </div>
                        <div className="filter-field-widgets-1">
                            <label htmlFor="mail">Email</label>
                            <input
                                type="text"
                                id="mail"
                                name="name"
                                size="30"
                                maxLength="128" 
                                value= {formData.name}  
                                className="" 
                                onChange={handleChange}
                            />
                        </div>
                        <div className="filter-field-widgets-1">
                          <label htmlFor="city">
                            City/Town
                          </label>
                          <input className="" type="text" id="city" name="field_city_value" 
                            value={formData.field_city_value} 
                            onChange={handleChange}
                            size="30" maxlength="50" 
                          />
                        </div>
                        <div className="filter-field-widgets-1">
                          <label htmlFor="zip">
                            Zip/Postal Code
                          </label>
                          <input className="" type="text" id="zip" name="field_postal_code_value" 
                            value={formData.field_postal_code_value}
                            onChange={handleChange}
                            size="30" maxlength="20" 
                          />
                        </div>
                        <div className="filter-field-widgets-1">
                          <label htmlFor="phone1">
                            Primary Phone
                          </label>
                          <input className='' type="text" id="phone1" name="field_phone_value" 
                            value={formData.field_phone_value} 
                            onChange={handleChange}
                            size="30" maxLength="20" 
                          />
                        </div>
                        <div className="filter-field-widgets-1">
                          <label htmlFor="phone2">
                            Secondary Phone
                          </label>
                          <input className='' type="text" id="phone2" name="field_secondary_phone_value"
                            value={formData.field_secondary_phone_value} 
                            onChange={handleChange} 
                            size="30" maxLength="20" 
                          />
                        </div>
                        <div className="filter-field-widgets-1">
                          <label htmlFor="address">
                            Street Address
                          </label>
                          <input className="" type="text" id="address" name="field_street_value" 
                            value={formData.field_street_value}
                            onChange={handleChange} 
                            size="30" maxLength="255" 
                          />
                        </div>
                        <div className="filter-field-widgets-1 university-field">
                          <label htmlFor="university">
                            University
                          </label>
                          <input className="" type="text" id="university" name="field_college_value" 
                            value={formData.field_college_value}
                            onChange={handleChange} 
                          />
                        </div>
                        <div className="user-flex">
                        <div className="filter-field-widgets-2">
                          <label htmlFor="appn_sportsreferrer">
                            Referrer
                          </label>
                          <select
                              className=''
                              name="field_referrer_value"
                                value={formData.field_referrer_value}
                                onChange={handleChange}
                                >
                              <option value="All">-Any-</option>
                              {SportsreferrerOptions.map((option, index) => (
                              <option key={index} value={option}>
                                  {option}
                              </option>
                              ))}
                          </select>
                        </div>
                        <div className="filter-field-widgets-2">
                          <label htmlFor="gender">Gender</label>
                          <select id="gender" name="field_gender_value" className="manage_people-form-select" 
                            value= {formData.field_gender_value} 
                            onChange={handleChange}
                          >
                            <option value="All">- Any -</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Non-binary">Non-binary</option>
                            <option value="Prefer not to answer">Prefer not to answer</option>
                          </select>
                        </div>
                        <div className="filter-field-widgets-2">
                          <label htmlFor="country">Country</label>                        
                          <Select                              
                            id="country" name="field_country_value" className=''
                            searchable={true}                             
                            clearable={true} 
                            clearOnBlur={true} 
                            clearOnSelect={true}
                            backspaceDelete={true}                              
                            style={{backgroundColor:'#ffffff',width:'199px',maxHeight:'24px',minHeight:'24px', borderRadius: 5}}                                                                                   
                            options={countriesList}                             
                            onChange={(val) => {
                              if(val.length == 0) {
                                console.log(val);
                              }
                              else{
                                setSelectedCountry(val);
                              handleChange(
                                { target: { value: val[0]['value'], name: 'field_country_value' } }
                              )
                              
                              }}
                            }
                            onDropdownOpen={handleOpen}
                            values={selectedcountry}                             
                          /> 
                        </div>
                        <div className="filter-field-widgets-2">
                          <label htmlFor="state">State </label>
                          <select className='' id="state" name="field_state_value" 
                            value={formData.field_state_value}  
                            onChange={handleChange} 
                          >
                            <option value="ALL">-Any-</option>
                            {Object.keys(statelist).map(state => {
                            return <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>
                            })}
                          </select>
                        </div>
                        </div>
                        <div style={{clear:"both"}}></div>
                        <div className="filter-field-widgets-2 roles-field">
                          <label htmlFor="rid">Roles</label>
                          <select id="rid" name="rid" className="manage_people-form-select" 
                            value= {formData.rid} 
                            onChange={handleChange}
                          >
                            <option value="All">- Any -</option>
                              {roleList.length > 0 && (
                                <>
                                  {roleList.map((item, index) => {
                                    return <>
                                        {item['id'] != null && (
                                        <><option value={item['id']}>{item['name']}</option></>
                                        )}
                                    </>
                                  })}  
                                </>
                              )}
                          </select>
                        </div>
                        <div className="filter-field-widgets-2">
                          <label htmlFor="status">Status</label>                                      
                          <select id="status" name="status" className="manage_people-form-select" 
                            value= {formData.status}   
                            onChange={handleChange}
                          >
                            <option value="All">- Any -</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                          </select>
                        </div>
                        <div className="filter-field-widgets-2">
                          <label htmlFor="memeber_of_military">Member of the Military?</label>                                      
                            <select id="memeber_of_military" name="field_military_value" className="manage_people-form-select" 
                              value= {formData.field_military_value}   
                              onChange={handleChange}
                            >
                              <option value="All">- Any -</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                      </div>
                      <div className="filter-field-widgets-2 app-register-step">
                        <label htmlFor="field-reg-step-value">App Register step</label>
                        <select
                          multiple
                          id="field-reg-step-value"
                          name="field_reg_step_value"
                          value={formData.field_reg_step_value}
                          onChange={handleChange}
                          size={3}
                          className="app-register-step-select"
                        >
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                        </select>
                      </div>
                      <div className="filter-field-widgets-2">
                        <label htmlFor="educationlevel">
                          Education Level Completed
                        </label>
                        <select
                          className=''
                          name="field_highest_grade_value"
                          value={formData.field_highest_grade_value}
                          onChange={handleChange}
                        >
                          <option value="All">-Any-</option>
                          {EducationlevelOptions.map((option, index) => (
                            <option key={index} value={option}>
                                {option}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="filter-field-widgets-2">
                        <label htmlFor="field-dormant">Dormant</label>
                        <select
                          id="field-dormant"
                          name="field_dormant_value"
                          value= {formData.field_dormant_value}
                          className="manage_people-form-select" 
                          onChange={handleChange}
                        >
                          <option value="All">- Any -</option>
                          <option value="0">Off</option>
                          <option value="1">On</option>
                      </select>
                      </div>
                      <div className="filter-field-widgets-2">
                        <label htmlFor="field-app-status">App Status</label>
                        <select
                          id="field-app-status"
                          name="field_app_status_value"
                          className=""
                          value={formData.field_app_status_value}
                          onChange={handleChange}
                        >
                          {appStatusOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="filter-field-widgets-2">
                        <label>Salesperson </label>
                        <select
                          className=' '
                          name="field_user_assignment_value"
                          value={formData.field_user_assignment_value}
                          onChange={handleChange}
                          style={{width:"100px"}}
                        >
                          <option value="ALL">-Any-</option>
                          {salespersonList.length > 0 && (
                              <>
                                {salespersonList.map((item, index) => {
                                    return <>
                                        {item['uid'] != null && (
                                        <><option value={item['uid']}>{item['name']}</option></>
                                        )}
                                    </>
                
                                })}  
                              </>
                          )}
                        </select>
                      </div>
                      <div className="filter-field-widgets-3 birthdate-fields" style={{width:"25%"}}>
                        <label>Birthdate</label>
                        <div className=''>
                          <label htmlFor="start_date">Start Date</label>
                          <DatePicker
                           ref={startDateRef}
                            // selected={
                            //   formData["field_birthday_value[min][date]"]
                            //     ? new Date(formData["field_birthday_value[min][date]"])
                            //     : null
                            // }
                            selected={formData["field_birthday_value[min][date]_obj"]}
                            onChange={(date) => {
                              handleDateChange(date, "field_birthday_value[min][date]");

                              setTimeout(() => {
                                const input = startDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                            }}
                            name="field_birthday_value[min][date]"
                            maxDate={currentDate}
                            required
                          />  
                          {formErrors["field_birthday_value[min][date]"] && (
                            <div className="error">{formErrors["field_birthday_value[min][date]"]}</div>
                          )}                 
                        </div>
                        <div className=''>
                          <label htmlFor="end_date">End Date</label>
                          <DatePicker
                             ref={endDateRef}
                            // selected={
                            //   formData["field_birthday_value[max][date]"]
                            //     ? new Date(formData["field_birthday_value[max][date]"])
                            //     : null
                            // }
                            selected={formData["field_birthday_value[max][date]_obj"]}
                            onChange={(date) => {
                              handleDateChange(date, "field_birthday_value[max][date]");

                              setTimeout(() => {
                                const input = endDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                            }}
                            name="field_birthday_value[max][date]"
                            maxDate={currentDate}
                            required
                          />  
                          {formErrors["field_birthday_value[max][date]"] && (
                            <div className="error">{formErrors["field_birthday_value[max][date]"]}</div>
                          )}                
                        </div>
                      </div>
                      <div className="filter-field-widgets-3 user-detail-input-size">
                        <label>Created Date</label>
                        <div className=''>
                          <label htmlFor="start_date">Start Date</label>
                          <DatePicker
                           ref={CreatedstartDateRef}
                            // selected={
                            //   formData["created[min]"]
                            //     ? new Date(formData["created[min]"])
                            //     : null
                            // }
                            selected={formData["created[min]_obj"]}
                                onChange={(date) => {
                              handleDateChange(date, "created[min]");

                              setTimeout(() => {
                                const input = CreatedstartDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                            }}
                            name="created[min]"
                            maxDate={currentDate}
                            required
                          />
                          {formErrors["created[min]"] && (
                            <div className="error">{formErrors["created[min]"]}</div>
                          )}                  
                        </div>
                        <div className=''>
                          <label htmlFor="end_date">End Date</label>
                          <DatePicker
                            ref={CreatedendDateRef}
                            // selected={
                            //   formData["created[max]"]
                            //     ? new Date(formData["created[max]"])
                            //     : null
                            // }
                            
                              selected={formData["created[max]_obj"]}
                              onChange={(date) => {
                              handleDateChange(date, "created[max]");

                              setTimeout(() => {
                                const input = CreatedendDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                            }}
                            name="created[max]"
                            maxDate={currentDate}
                            required
                          />                   
                          {formErrors["created[max]"] && (
                            <div className="error">{formErrors["created[max]"]}</div>
                          )}
                        </div>
                      </div>
                      <div className="filter-field-widgets-3">
                        <label>Updated Date</label>
                        <div className=''>
                            <label htmlFor="start_date">Start Date</label>
                            <DatePicker
                            ref={UpdatedstartDateRef}
                              // selected={
                              //   formData["field_date_of_app_value[min][date]"]
                              //     ? new Date(formData["field_date_of_app_value[min][date]"])
                              //     : null
                              // }
                              selected={formData["field_date_of_app_value[min][date]_obj"]}
                              onChange={(date) => {
                              handleDateChange(date, "field_date_of_app_value[min][date]");

                              setTimeout(() => {
                                const input = UpdatedstartDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                            }}
                              name="field_date_of_app_value[min][date]"
                              maxDate={currentDate}
                              required
                            />  
                            {formErrors["field_date_of_app_value[min][date]"] && (
                              <div className="error">{formErrors["field_date_of_app_value[min][date]"]}</div>
                            )}                  
                        </div>
                        <div className=''>
                            <label htmlFor="end_date">End Date</label>
                            <DatePicker
                            ref={UpdatedendDateRef}
                              // selected={
                              //   formData["field_date_of_app_value[max][date]"]
                              //     ? new Date(formData["field_date_of_app_value[max][date]"])
                              //     : null
                              // }
                              selected={formData["field_date_of_app_value[max][date]_obj"]}
                              onChange={(date) => {
                              handleDateChange(date, "field_date_of_app_value[max][date]");

                              setTimeout(() => {
                                const input = UpdatedendDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                            }}
                              name="field_date_of_app_value[max][date]"
                              maxDate={currentDate}
                              required
                            />                   
                            {formErrors["field_date_of_app_value[max][date]"] && (
                              <div className="error">{formErrors["field_date_of_app_value[max][date]"]}</div>
                            )}
                        </div>
                      </div>
                      <div className="filter-field-widgets tell-us-story-field user-detail-input-size">
                        <label htmlFor="story">Tell Us Your Story </label>
                        <input className="" type="text" id="story" name="field_elaborate_value" maxlength="128" 
                          value={formData.field_elaborate_value}
                          onChange={handleChange} 
                        />
                      </div>
                      <div className="filter-field-widgets user-detail-input-size">
                        <label htmlFor="team">What team/organization are you with?</label>
                        <input className='' type="text" id="team" name="field_team_organization_value"
                          value={formData. field_team_organization_value} 
                          onChange={handleChange} 
                        />
                      </div>
                      <div className="filter-field-widgets">
                          <button className='form-submit manage_people-formsubmit' type="submit"
                            onClick={handleSubmit}
                          >Apply</button>&nbsp;&nbsp;
                          <button className='form-submit manage_people-formsubmit' type="button"
                            onClick={handleReset}
                          >Reset</button>
                      </div>
                    </form>
                  </div>
                  <div className="result-container">
                    <div className="manage_people-view-content">
                      <table className="user-advanced-search-views-table">
                        <div style={{ width: '100%' }}>
                          <DataGrid
                            rows={rows}
                            columns={columns}
                            rowCount={rowCount}
                            paginationMode="server"
                            sortingMode="server"
                            filterMode="server"
                            paginationModel={paginationModel}
                            onPaginationModelChange={setPaginationModel}
                            sortModel={sortModel}
                            onSortModelChange={setSortModel}
                            filterModel={filterModel}
                            onFilterModelChange={setFilterModel}
                            pageSizeOptions={[5, 10, 25,50]}
                            getRowId={() => crypto.randomUUID()}
                            getRowHeight={() => 'auto'}
                            disableColumnFilter 
                            disableColumnResize={true}
                          />
                        </div>
                      </table>
                    </div>
                  </div>
                </div>
            </div>
            <div className="right">
          </div>
        </div>
      )}
    </>
       
    );

};
export default UserAdvancedSearch;